/** The "T" that stands in for a text item where icons and logos show their artwork. Drawn in `currentColor`. */
export const TextGlyph: React.FC = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' aria-hidden='true'>
    <path
      d='M3.33301 5.83301V3.33301H16.6663V5.83301'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.50061 16.6665H12.5006'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.99988 3.33301V16.6663'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
